import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-cancelled-page',
  templateUrl: './cancelled.component.html',
  styleUrls: ['./cancelled.component.css']
})
export class CancelledComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
